<template>
    <v-tab-item :value="thisTab" class="fill-height">
        <v-layout column justify-center class="h-100">
            <div style="flex:1; overflow:hidden">
                <form-body
                    v-model="form"
                    v-bind="{
                        index,
                    }"
                    mode="sign"
                    @input="emit"
                />
            </div>
            <v-divider />
            <form-noti v-model="disabled" v-bind="{ form }" />
            <div class="v-btn-group flex-wrap my-12">
                <v-btn
                    outlined
                    color="grey-d"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('prev')"
                >
                    <v-icon color="grey-6">mdi-chevron-left</v-icon>
                    <span class="grey-6--text"> 이전 단계 </span>
                </v-btn>
                <v-btn
                    color="primary"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                        disabled,
                    }"
                    @click="$emit('next')"
                >
                    <span> 입력 완료 </span>
                    <v-icon style="color:white!important">mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </v-layout>
    </v-tab-item>
</template>

<script>
import { initEmploymentContract } from "@/assets/variables";

import { TABS } from "../lib";

import EmploymentDocSide from "@/components/dashboard/common/employment/doc/employment-doc-side.vue";
import FormBody from "./form/form-body.vue";
import FormNoti from "./form/form-noti.vue";

const thisTab = TABS.FORM.value;

export default {
    components: {
        EmploymentDocSide,
        FormBody,
        FormNoti,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
        tab: { type: String, default: TABS.VIEW.value },
        shows: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initEmploymentContract(),
        index: 0,
        disabled: undefined,

        thisTab,
    }),
    computed: {
        isOn() {
            return this.shows && this.tab == thisTab;
        },
        pages() {
            return this.form?.form?.pages || [];
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentContract(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>
